import React, { Component } from 'react';

export default class FormField extends Component {

  constructor() {
    super();

    this.state = {
      id: Math.random().toString(36).substring(7)
    }
  }


  render() {

    let className = 'form-field';
    if(this.props.className) {
      className = this.props.className;
    }

    let type = this.props.type || 'input';

    let inputField = null;

    switch(type) {
      case 'input':
        inputField = <input name={this.props.name} id={this.state.id} type="text"/>;
        break;
      case 'textarea':
        inputField = <textarea name={this.props.name} id={this.state.id} type="text"></textarea>;
        break;
    }

    return (
      <div className={className}>
        <label htmlFor={this.state.id}>{this.props.label}</label>
        {inputField}
      </div>
    )
  }
}

FormField.defaultProps = {
  label: 'Input',
  name: 'input'
};



// WEBPACK FOOTER //
// ./src/elements/form/fields/FormField.js